export default {
  common: {
    account: '帳戶',
    return: '返回上一頁'
  },
  button: {
    returnTop: '返回首頁',
    rangeSelect: '選擇乘車區間、時間',
    busSelect: '選擇巴士',
    reserveConfirm: '完成預訂',
    reserveCancel: '取消預訂'
  },
  view: {
    ticket: '車票',
    fromAirport: '機場出發',
    toAirport: '前往機場',
    directionDep: '出發',
    directionDepDesc: '機場 → 目的地',
    directionArr: '抵達',
    directionArrDesc: '目的地 → 機場',
    pleaseSelectBus: '請選擇巴士',
    availablePeriod: '可使用期間',
    useInstruction: '使用說明',
    adultCount: '大人 × {{count}}位',
    childCount: '兒童 × {{count}}位',
    disabledAdultCount: '身心障礙者(大人) × {{count}}位',
    rangeAndSchedule: '乘車區間及預定乘車日',
    pleaseSelect: '請選擇',
    ridingDate: '乘車日',
    ridingPlace: '出發',
    departurePlace: '搭乘地點',
    arrivalPlace: '抵達',
    company: '營運公司',
    availableSeatsCount: '剩餘座位',
    ridingBusTime: '巴士行駛時間',
    buyTicket: '票數',
    reservationRideInfo: '訂購明細',
    inReserve: '購票處理中，請稍候',
    thankForReservation: '感謝您的購買。',
    reservationConfirmed: '以下訂單已完成。',
    inCancel: '取消訂單中，請稍候',
    cancelInfo: '取消訂單明細',
    isCanceled: '已完成取消訂單。',
    notAvailableBus: '找不到所要求區間和乘車日的營運巴士。',
    currentJapanTime: '當前日本時間: {{time}}',
    baseJapanTime: '下面的時間以日本時間為準。',
    remainsCount: '剩餘座位數'
  }
};
